export const pageview = (gaId: string, url: string) => {
	try {
		window.gtag('config', gaId, {
			page_path: url
		});
	} catch (error) {
		console.log(error);
	}
};
